import { Badge } from '../ui/badge';
import { statusLabel, statusBadgeClass } from './meetingsUtils';

export default function MeetingStatusBadge({ status, testId }) {
  return (
    <Badge variant="outline" className={`shrink-0 ${statusBadgeClass(status)}`} data-testid={testId || `meeting-status-${status}`}>
      {statusLabel(status)}
    </Badge>
  );
}
